import swedish from './locales/sv-SE.json';
import norwegian from './locales/nb-NO.json';
import english from './locales/en.json';
import german from './locales/de-DE.json';

type TranslationValue = string | TranslationObject | TranslationValue[];
interface TranslationObject {
  [key: string]: TranslationValue;
}

type LocaleMessages = TranslationObject;

const messages: Record<string, LocaleMessages> = {
  'sv-SE': swedish,
  'nb-NO': norwegian,
  'de-DE': german,
  en: english,
};

export default messages;
